module.exports = __webpack_public_path__ + "img/20241119_3.b85346bf.jpg";